// The upload pipeline (server/src/controllers/uploadsController.js)
// writes each image as `<id>-thumb.webp` / `-medium.webp` / `-full.webp`
// and stores only the "full" URL on the product — the other sizes are
// derived here by the same naming convention rather than needing extra
// columns or another round-trip. Falls back to the original URL for
// anything that doesn't match (e.g. an old seed-data path), so a plain
// <img src> never breaks.
export function getImageVariants(url) {
  if (!url || !url.includes("-full.webp")) {
    return { thumb: url, medium: url, full: url };
  }
  return {
    thumb: url.replace("-full.webp", "-thumb.webp"),
    medium: url.replace("-full.webp", "-medium.webp"),
    full: url,
  };
}
